import { getUserSession } from './userSession';

function parseJwtUserId(token) {
    if (!token || typeof token !== 'string') {
        return null;
    }
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const id = payload?.id;
        return id == null || id === '' ? null : Number(id);
    } catch (e) {
        return null;
    }
}

/**
 * Resolve owner userId and screenId for screen-host dashboard API calls.
 * Team members act on behalf of ownerUserId; owners use their own id.
 */
export function resolveScreenHostContext(state, token) {
    const session = getUserSession() || {};
    const actorUserId =
        session.actorUserId ??
        state?.actorUserId ??
        parseJwtUserId(token) ??
        (session.userId != null ? Number(session.userId) : null);

    const ownerUserId =
        session.ownerUserId ??
        state?.ownerUserId ??
        session.userId ??
        state?.userId ??
        state?.UserId ??
        session.UserId ??
        actorUserId;

    const userId = ownerUserId;
    const role = session.hostRole ?? state?.hostRole ?? 'owner';
    const screenId =
        state?.screenId ??
        state?.ScreenId ??
        session.screenId ??
        session.ScreenId;

    return {
        userId,
        ownerUserId,
        actorUserId,
        role,
        screenId,
        teamMemberOnly: Boolean(session.teamMemberOnly ?? state?.teamMemberOnly),
        isTeamDelegate: Boolean(session.isTeamDelegate ?? state?.isTeamDelegate),
    };
}

export async function loadAndPersistScreenHostTeamContext(token, persistUserSession) {
    const { fetchScreenHostTeamContext } = await import('./screenHostTeam');
    const response = await fetchScreenHostTeamContext(token);
    const data = response.data;

    if (!data?.success) {
        throw new Error('Failed to load team context');
    }

    const actorUserId = data.actorUserId;
    const hasMemberships = Array.isArray(data.memberships) && data.memberships.length > 0;
    const teamMemberOnly = Boolean(data.teamMemberOnly) || hasMemberships;
    let ownerUserId = data.ownerUserId ?? data.activeOwnerUserId ?? actorUserId;
    let role = data.role ?? 'owner';

    if (hasMemberships) {
        const activeMembership = data.memberships.length === 1
            ? data.memberships[0]
            : data.memberships.find((m) => m.ownerUserId === ownerUserId) || data.memberships[0];
        ownerUserId = activeMembership.ownerUserId;
        role = activeMembership.role;
    }

    const updates = {
        actorUserId,
        ownerUserId,
        hostRole: role,
        userId: ownerUserId,
        teamMemberOnly,
        isTeamDelegate: hasMemberships,
    };

    if (typeof persistUserSession === 'function') {
        persistUserSession(updates);
    }

    return updates;
}
